
// import colors from "assets/theme/base/colors";

// const { gradients, dark } = colors;

// function configs(labels, datasets) {
//   const backgroundColors = [];

//   if (datasets.backgroundColors) {
//     datasets.backgroundColors.forEach((color) =>
//       gradients[color]
//         ? backgroundColors.push(gradients[color].state)
//         : backgroundColors.push(dark.main)
//     );
//   } else {
//     backgroundColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           weight: 9,
//           cutout: 0,
//           tension: 0.9,
//           pointRadius: 2,
//           borderWidth: 2,
//           backgroundColor: backgroundColors,
//           fill: false,
//           data: datasets.data,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: {
//           display: false,
//         },
//       },
//       interaction: {
//         intersect: false,
//         mode: "index",
//       },
//       scales: {
//         y: {
//           grid: {
//             drawBorder: false,
//             display: false,
//             drawOnChartArea: false,
//             drawTicks: false,
//           },
//           ticks: {
//             display: false,
//           },
//         },
//         x: {
//           grid: {
//             drawBorder: false,
//             display: false,
//             drawOnChartArea: false,
//             drawTicks: false,
//           },
//           ticks: {
//             display: false,
//           },
//         },
//       },
//     },
//   };
// }

// export default configs;

// ########################################

// import colors from "assets/theme/base/colors";

// const { gradients, dark } = colors;

// function configs(labels, datasets) {
//   const backgroundColors = [];

//   if (datasets.backgroundColors) {
//     datasets.backgroundColors.forEach((color) =>
//       gradients[color]
//         ? backgroundColors.push(gradients[color].state)
//         : backgroundColors.push(color)
//     );
//   } else {
//     backgroundColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           weight: 9,
//           cutout: 0,
//           tension: 0.9,
//           pointRadius: 2,
//           borderWidth: 2,
//           backgroundColor: backgroundColors,
//           fill: false,
//           data: datasets.data,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: {
//           display: false,
//         },
//       },
//       interaction: {
//         intersect: false,
//         mode: "index",
//       },
//       scales: {
//         y: {
//           grid: {
//             drawBorder: false,
//             display: false,
//             drawOnChartArea: false,
//             drawTicks: false,
//           },
//           ticks: {
//             display: false,
//           },
//         },
//         x: {
//           grid: {
//             drawBorder: false,
//             display: false,
//             drawOnChartArea: false,
//             drawTicks: false,
//           },
//           ticks: {
//             display: false,
//           },
//         },
//       },
//     },
//   };
// }

// export default configs;



// src/examples/Charts/PieChart/configs/index.js

// import colors from "assets/theme/base/colors";

// const { gradients, dark } = colors;

// // Utility: return a dimmed (alpha) version of any hex/rgb/rgba color
// const dim = (c, a = 0.3) => {
//   if (!c) return c;

//   // #rgb or #rrggbb
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // rgb() / rgba()
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // fallback – if it's some named color or gradient value already rgba
//   return c;
// };

// function configs(labels, datasets) {
//   // preserve the exact input colors (mapped through theme gradients if key is provided)
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,

//           // Dynamic bg to dim non-hovered slices. Colors revert automatically when hover ends.
//           backgroundColor: (ctx) => {
//             const i = ctx.dataIndex;
//             const active = ctx.chart.getActiveElements?.() || ctx.chart._active || [];
//             const anyActive = active.length > 0;
//             const isThisActive = anyActive && active[0].index === i;
//             console.log("🎨 Pie slice", i, "active?", isThisActive, "anyActive?", anyActive, "baseColors", baseColors[i]);
//             return anyActive && !isThisActive ? dim(baseColors[i], 0.3) : baseColors[i];
//           },

//           // Visual tweaks (optional)
//           borderWidth: 2,
//           hoverBorderWidth: 0,
//           hoverBorderColor: "transparent",
//           hoverOffset: 14,     // “elevate” the hovered slice
//           weight: 9,
//           cutout: 0,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       layout: { padding: 0 },
//       elements: { arc: { borderWidth: 0 } },
//       plugins: { legend: { display: false }, tooltip: { enabled: true } },
//       interaction: { mode: "nearest", intersect: true },
//       animation: { duration: 200 },
//       // axes are not used for pie, omit noisy config
//     },
//   };
// }

// export default configs;


// import colors from "assets/theme/base/colors";

// const { gradients, dark } = colors;

// // Utility: return a dimmed (alpha) version of any hex/rgb/rgba color
// const dim = (c, a = 0.3) => {
//   if (!c) return c;

//   // #rgb or #rrggbb
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // rgb() / rgba()
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // fallback – if it's some named color or gradient value already rgba
//   return c;
// };

// function configs(labels, datasets) {
//   // preserve the exact input colors (mapped through theme gradients if key is provided)
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,

//           // Dynamic bg to dim non-hovered slices. Colors revert automatically when hover ends.
//           backgroundColor: (ctx) => {
//             const i = ctx.dataIndex;

//             // Prefer our tracked active set (populated in options.onHover).
//             const activeSet = ctx.chart.$activeSet;
//             if (activeSet && activeSet.size > 0) {
//               const key = `${ctx.datasetIndex}:${i}`;
//               return activeSet.has(key) ? baseColors[i] : dim(baseColors[i], 0.3);
//             }

//             // Fallback to Chart.js active elements (first load / safety).
//             const active = ctx.chart.getActiveElements?.() || ctx.chart._active || [];
//             const anyActive = active.length > 0;
//             const isThisActive = anyActive && active[0].index === i;
//             return anyActive && !isThisActive ? dim(baseColors[i], 0.3) : baseColors[i];
//           },

//           // Visual tweaks (optional)
//           borderWidth: 2,
//           hoverBorderWidth: 0,
//           hoverBorderColor: "transparent",
//           hoverOffset: 14,     // “elevate” the hovered slice
//           weight: 9,
//           cutout: 0,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
// options: {
//   responsive: true,
//   maintainAspectRatio: false,
//   layout: { padding: 0 },
//   elements: { arc: { borderWidth: 0 } },

//   // ✅ Ensure we get the right DOM events
//   events: ["mousemove", "mouseout", "mouseleave", "click", "touchstart", "touchmove"],

//   // ✅ Recompute all slice colors on hover + clear on leave
//   onHover: (event, activeEls, chart) => {
//     const next = new Set(activeEls.map(el => `${el.datasetIndex}:${el.index}`));
//     const prev = chart.$activeSet;

//     // If cursor left the chart area (no elements active), clear and refresh
//     if (next.size === 0 && prev && prev.size > 0) {
//       chart.$activeSet = null;
//       chart.update("none"); // immediate redraw -> all slices back to original color
//       return;
//     }

//     let changed = !prev || prev.size !== next.size;
//     if (!changed && prev) {
//       for (const k of next) { if (!prev.has(k)) { changed = true; break; } }
//     }
//     if (changed) {
//       chart.$activeSet = next;
//       chart.update("none");
//     }
//   },

//   // ✅ Also reset when tooltip hides (covers cases where mouseout isn't fired on <canvas>)
//   plugins: {
//     legend: { display: false },
//     tooltip: {
//       enabled: true,
//       external: (ctx) => {
//         const { chart, tooltip } = ctx;
//         if (!tooltip || tooltip.opacity === 0) {
//           if (chart.$activeSet && chart.$activeSet.size > 0) {
//             chart.$activeSet = null;
//             chart.update("none");
//           }
//         }
//       },
//     },
//   },

//   interaction: { mode: "nearest", intersect: true },
//   animation: { duration: 200 },
// },
//   };
// }

// export default configs;






// import colors from "assets/theme/base/colors";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Chart } from "react-chartjs-2";

// const { gradients, dark } = colors;

// // Utility: return a dimmed (alpha) version of any hex/rgb/rgba color
// const dim = (c, a = 0.3) => {
//   if (!c) return c;

//   // #rgb or #rrggbb
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // rgb() / rgba()
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // fallback – if it's some named color or gradient value already rgba
//   return c;
// };

// // ⚙️ Register the necessary Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend);

// function configs(labels, datasets) {
//   // preserve the exact input colors (mapped through theme gradients if key is provided)
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,
//           backgroundColor: baseColors,
//           borderWidth: 2,
//           hoverBorderWidth: 0,
//           hoverBorderColor: "transparent",
//           hoverOffset: 14,
//           weight: 9,
//           cutout: 0,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       layout: { padding: 0 },
//       elements: { arc: { borderWidth: 0 } },
//       plugins: {
//         legend: { display: false },
//         tooltip: { enabled: true }
//       },
//       interaction: {
//         mode: "nearest",
//         intersect: true
//       },
//       animation: {
//         duration: 200
//       },
//       // ✅ Use onHover to control the animation and color change
//       onHover: (event, activeElements, chart) => {
//         const dataset = chart.data.datasets[0];
//         const originalColors = chart.data.datasets[0].backgroundColor;
        
//         if (activeElements.length > 0) {
//           const activeIndex = activeElements[0].index;
//           const newColors = originalColors.map((c, i) => i === activeIndex ? c : dim(c, 0.3));
//           dataset.backgroundColor = newColors;
//           chart.update('none');
//         } else {
//           // If no element is hovered, reset to original colors
//           dataset.backgroundColor = baseColors;
//           chart.update('none');
//         }
//       },
//     },
//   };
// }

// export default configs;




// import colors from "assets/theme/base/colors";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Chart } from "react-chartjs-2";

// const { gradients, dark } = colors;

// // Utility: return a dimmed (alpha) version of any hex/rgb/rgba color
// const dim = (c, a = 0.3) => {
//   if (!c) return c;

//   // #rgb or #rrggbb
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // rgb() / rgba()
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // fallback – if it's some named color or gradient value already rgba
//   return c;
// };

// // ⚙️ Register the necessary Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend);

// function configs(labels, datasets) {
//   // preserve the exact input colors (mapped through theme gradients if key is provided)
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,
//           backgroundColor: baseColors,
//           borderWidth: 2,
//           hoverBorderWidth: 2,
//           hoverBorderColor: "grey",
//           hoverOffset: 14,
//           weight: 9,
//           cutout: 30,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       layout: { padding: 10 },
//       elements: { arc: { borderWidth: 0 } },
//       plugins: {
//         legend: { display: false },
//         tooltip: { enabled: true }
//       },
//       interaction: {
//         mode: "nearest",
//         intersect: true
//       },
//       animation: {
//         duration: 200
//       },
//       // ✅ Use onHover to control the animation and color change
//       onHover: (event, activeElements, chart) => {
//         const dataset = chart.data.datasets[0];

//         // 🟢 Always reset to the original colors first
//         dataset.backgroundColor = baseColors;

//         if (activeElements.length > 0) {
//           const activeIndex = activeElements[0].index;
//           const newColors = baseColors.map((c, i) => i === activeIndex ? c : dim(c, 0.3));
//           dataset.backgroundColor = newColors;
//         }

//         chart.update('none');
//       },
//     },
//   };
// }

// export default configs;


// import colors from "assets/theme/base/colors";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Chart } from "react-chartjs-2";

// const { gradients, dark } = colors;

// // Utility: return a dimmed (alpha) version of any hex/rgb/rgba color
// const dim = (c, a = 0.3) => {
//   if (!c) return c;

//   // #rgb or #rrggbb
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // rgb() / rgba()
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }

//   // fallback – if it's some named color or gradient value already rgba
//   return c;
// };

// // ⚙️ Register the necessary Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend);

// function configs(labels, datasets) {
//   // preserve the exact input colors (mapped through theme gradients if key is provided)
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,
//           backgroundColor: baseColors,
//           borderWidth: 2,
//           hoverBorderWidth: 0,
//           hoverBorderColor: "black",
//           hoverOffset: 14,
//           weight: 9,
//           cutout: 50,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       layout: { padding: 10 },
//       elements: { arc: { borderWidth: 0 } },
//       plugins: {
//         legend: { display: false },
//         tooltip: { enabled: true }
//       },
//       interaction: {
//         mode: "nearest",
//         intersect: true
//       },
//       animation: {
//         duration: 200
//       },
//       // ✅ Use onHover to control the animation and color change
//       onHover: (event, activeElements, chart) => {
//         const dataset = chart.data.datasets[0];
        
//         // When the mouse is not hovering over any element
//         if (activeElements.length === 0) {
//           dataset.backgroundColor = baseColors;
//         } else {
//           // If a specific slice is active, set its color to the base color and dim the others
//           const activeIndex = activeElements[0].index;
//           const newColors = baseColors.map((c, i) => i === activeIndex ? c : dim(c, 0.3));
//           dataset.backgroundColor = newColors;
//         }

//         chart.update('none');
//       },
//     },
//   };
// }

// export default configs;


// import colors from "assets/theme/base/colors";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Chart } from "react-chartjs-2";

// const { gradients, dark } = colors;

// // dim helper
// const dim = (c, a = 0.3) => {
//   if (!c) return c;
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }
//   return c;
// };

// ChartJS.register(ArcElement, Tooltip, Legend);

// function configs(labels, datasets) {
//   // exact input colors (mapped through theme if key)
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   // plugin: reset colors when pointer leaves the canvas (covers “fast exit” case)
//   const resetOnLeavePlugin = {
//     id: "resetOnLeave",
//     afterInit(chart) {
//       const reset = () => {
//         const ds = chart.data.datasets?.[0];
//         if (!ds) return;
//         // restore only if currently dimmed
//         const equal =
//           Array.isArray(ds.backgroundColor) &&
//           ds.backgroundColor.length === baseColors.length &&
//           ds.backgroundColor.every((c, i) => c === baseColors[i]);
//         if (!equal) {
//           ds.backgroundColor = baseColors.slice(); // <-- copy
//           chart.update("none"); // quick redraw, no layout
//         }
//       };
//       chart.$resetOnLeave = reset;
//       chart.canvas.addEventListener("mouseleave", reset);
//       chart.canvas.addEventListener("touchend", reset, { passive: true });
//     },
//     destroy(chart) {
//       if (chart.$resetOnLeave) {
//         chart.canvas.removeEventListener("mouseleave", chart.$resetOnLeave);
//         chart.canvas.removeEventListener("touchend", chart.$resetOnLeave);
//         chart.$resetOnLeave = null;
//       }
//     },
//   };

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,
//           backgroundColor: baseColors.slice(), // <-- copy
//           borderWidth: 2,
//           hoverBorderWidth: 0,
//           hoverBorderColor: "black",
//           hoverOffset: 14,
//           weight: 9,
//           cutout: 50,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       layout: { padding: 10 },
//       elements: { arc: { borderWidth: 0 } },
//       plugins: {
//         legend: { display: false },
//         tooltip: { enabled: true },
//       },
//       // include mouse/touch leave events so hover bookkeeping is robust
//       events: ["mousemove", "mouseout", "mouseleave", "click", "touchstart", "touchmove", "touchend"],
//       interaction: { mode: "nearest", intersect: true },
//       animation: { duration: 200 },

//       // dim others on hover; restore when none active
//       onHover: (event, activeElements, chart) => {
//         const ds = chart.data.datasets[0];
//         if (!ds) return;

//         if (activeElements.length === 0) {
//           // not hovering anything -> restore
//           ds.backgroundColor = baseColors.slice(); // <-- copy
//         } else {
//           const activeIndex = activeElements[0].index;
//           ds.backgroundColor = baseColors.map((c, i) => (i === activeIndex ? c : dim(c, 0.3)));
//         }
//         chart.update("none");
//       },
//     },
//     // register the plugin per-instance
//     plugins: [resetOnLeavePlugin],
//   };
// }

// export default configs;



// import colors from "assets/theme/base/colors";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Chart } from "react-chartjs-2";

// const { gradients, dark } = colors;

// // A utility to get a color with a slight variation for highlighting
// const getHighlightColor = (c) => {
//   if (!c) return "black";
//   const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
//   if (hex) {
//     let h = hex[1];
//     if (h.length === 3) h = h.split("").map((x) => x + x).join("");
//     const n = parseInt(h, 16);
//     const r = Math.min(255, (n >> 16) & 255);
//     const g = Math.min(255, (n >> 8) & 255);
//     const b = Math.min(255, n & 255);
//     return `rgb(${r}, ${g}, ${b})`;
//   }
//   const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
//   if (m) {
//     const [_, r, g, b] = m;
//     return `rgb(${r}, ${g}, ${b})`;
//   }
//   return c;
// };

// ChartJS.register(ArcElement, Tooltip, Legend);

// function configs(labels, datasets) {
//   const baseColors = [];
//   if (datasets.backgroundColors && datasets.backgroundColors.length) {
//     datasets.backgroundColors.forEach((c) =>
//       gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
//     );
//   } else {
//     baseColors.push(dark.main);
//   }

//   return {
//     data: {
//       labels,
//       datasets: [
//         {
//           label: datasets.label,
//           data: datasets.data,
//           backgroundColor: baseColors.slice(),
//           borderWidth: 0,
//           hoverBorderWidth: 4,
//           hoverBorderColor: (ctx) => {
//             const index = ctx.dataIndex;
//             return getHighlightColor(baseColors[index]);
//           },
//           hoverOffset: 20,
//           weight: 9,
//           cutout: 50,
//           tension: 0.9,
//           pointRadius: 2,
//           fill: false,
//         },
//       ],
//     },
//     options: {
//       responsive: true,
//       maintainAspectRatio: false,
//       layout: { padding: 10 },
//       elements: { arc: { borderWidth: 0 } },
//       plugins: {
//         legend: { display: false },
//         tooltip: {
//           enabled: true
//         },
//       },
//       events: ["mousemove", "mouseout", "mouseleave", "click", "touchstart", "touchmove", "touchend"],
//       interaction: {
//         mode: "nearest",
//         intersect: true
//       },
//       animation: {
//         duration: 200
//       },
//     },
//     // No custom plugins needed, as Chart.js handles it directly
//     plugins: [],
//   };
// }

// export default configs;


import colors from "assets/theme/base/colors";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";

const { gradients, dark } = colors;

// A utility to get a color with a slight variation for highlighting
const getHighlightColor = (c) => {
  if (!c) return "black";
  const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(c);
  if (hex) {
    let h = hex[1];
    if (h.length === 3) h = h.split("").map((x) => x + x).join("");
    const n = parseInt(h, 16);
    const r = Math.min(255, (n >> 16) & 255);
    const g = Math.min(255, (n >> 8) & 255);
    const b = Math.min(255, n & 255);
    return `rgb(${r}, ${g}, ${b})`;
  }
  const m = c.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,(0|0?\.\d+|1))?\)$/i);
  if (m) {
    const [_, r, g, b] = m;
    return `rgb(${r}, ${g}, ${b})`;
  }
  return c;
};

ChartJS.register(ArcElement, Tooltip, Legend);

function configs(labels, datasets) {
  const baseColors = [];
  if (datasets.backgroundColors && datasets.backgroundColors.length) {
    datasets.backgroundColors.forEach((c) =>
      gradients[c] ? baseColors.push(gradients[c].state) : baseColors.push(c)
    );
  } else {
    baseColors.push(dark.main);
  }

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          data: datasets.data,
          backgroundColor: baseColors.slice(),
          borderWidth: 0,
          hoverBorderWidth: 4,
          hoverBorderColor: (ctx) => {
            const index = ctx.dataIndex;
            return getHighlightColor(baseColors[index]);
          },
          hoverOffset: 20,
          weight: 9,
          cutout: 50,
          tension: 0.9,
          pointRadius: 2,
          fill: false,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: { padding: 10 },
      elements: { arc: { borderWidth: 0 } },
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: true,
          callbacks: {
            // ✅ Customize the tooltip title to be just the content type
            title: (tooltipItems) => {
              return tooltipItems[0].label;
            },
            // ✅ Customize the tooltip label to show the value and percentage
            label: (tooltipItem) => {
              const data = tooltipItem.dataset.data;
              const total = data.reduce((sum, val) => sum + val, 0);
              const value = tooltipItem.raw;
              const percentage = ((value / total) * 100).toFixed(1);
              return `${value} (${percentage}%)`;
            },
          },
        },
      },
      events: ["mousemove", "mouseout", "mouseleave", "click", "touchstart", "touchmove", "touchend"],
      interaction: {
        mode: "nearest",
        intersect: true
      },
      animation: {
        duration: 200
      },
    },
    // No custom plugins needed, as Chart.js handles it directly
    plugins: [],
  };
}

export default configs;

